import React from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

import { styles } from '../styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledMenuItemButton = styled(ListItemButton)(({ theme }) => stylesFromTheme(theme).menuItemButton || {});
const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => stylesFromTheme(theme).menuIcon || {});
const StyledListItemText = styled(ListItemText)(({ theme }) => stylesFromTheme(theme).menuText || {});

export class MenuItem extends React.Component {
  render() {
    const { Icon, itemClass, menuText, onClick } = this.props;

    return (
      <React.Fragment>
        <ListItem disablePadding>
          <StyledMenuItemButton
            onClick={onClick}
            className={itemClass}
          >
            {Icon && (
              <StyledListItemIcon>
                <Icon />
              </StyledListItemIcon>
            )}

            <StyledListItemText
              slotProps={{
                primary: {
                  variant: 'subtitle2',
                  sx: (theme) => ({
                    fontWeight: 'normal',
                    color: theme.palette.secondary.contrastText,
                    cursor: 'pointer',
                    textAlign: 'left',
                    marginLeft: Icon ? theme.spacing(-4) : theme.spacing(4),
                  }),
                },
              }}
              primary={menuText}
            />
          </StyledMenuItemButton>
        </ListItem>
      </React.Fragment>
    );
  }
}

export default MenuItem;